import type { Fragment, RingCtx } from '../types';
import { svgEl } from '../../core/svg';
import { metricsAt, W } from './metrics';

/**
 * Thin concentric hairlines: the ring itself plus the edges of the month band.
 *
 * Drawn at `ctx.radius`, so a circle on an orbit or nested inside another is
 * the same drawing at its own size. A parent whose children have split away is
 * a ghost (docs/CIRCLES.md §2) — still there, holding its own events, but faint
 * enough that the eye goes to the children that left it.
 */
export const ringFragment: Fragment<RingCtx> = (ctx, state) => {
  const M = metricsAt(ctx.radius);
  const g = svgEl('g', { 'data-frag': 'ring' });

  const circle = (r: number, stroke: string, width: number, opacity?: number) =>
    svgEl('circle', {
      cx: 0,
      cy: 0,
      r,
      fill: 'none',
      stroke,
      'stroke-width': width,
      'vector-effect': 'non-scaling-stroke',
      opacity,
    });

  g.append(circle(M.bandInner, 'var(--hairline)', W.hairline));
  g.append(circle(M.bandOuter, 'var(--hairline)', W.hairline, 0.7));
  g.append(
    circle(
      ctx.radius,
      state.selected ? 'var(--accent)' : ctx.style?.colour || 'var(--ring-strong)',
      W.ring,
    ),
  );

  if (ctx.ghost) g.setAttribute('opacity', '0.45');
  return g;
};
